module.exports = __webpack_public_path__ + "img/logoApplePc_c.f26d15c8.svg";